import { render, staticRenderFns } from "./MainCover.vue?vue&type=template&id=37755353&scoped=true&"
import script from "./MainCover.vue?vue&type=script&lang=js&"
export * from "./MainCover.vue?vue&type=script&lang=js&"
import style0 from "./MainCover.vue?vue&type=style&index=0&id=37755353&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37755353",
  null
  
)

export default component.exports